<template>
  <div class="col-12 col-lg-4 mt-lg-0 pr-lg-2">
    <div class="bcard card h-100">
      <div class="card-header brc-grey-l3 pb-2">
        <h5 class="card-title font-normal text-120 text-dark-m1 pl-1">
          Promet po mesecima
        </h5>

        <!-- dropdown menu -->
        <div class="card-toolbar no-border">
          <div class="dropdown dd-backdrop dd-backdrop-none-md">
            <a class="btn btn-sm btn-lighter-secondary text-600 btn-bgc-white brc-secondary-l1 brc-h-secondary-m4 ml-1 dropdown-toggle" href="#" role="button" data-toggle="dropdown" data-display="static" aria-haspopup="true" aria-expanded="false">
              <i class="far fa-calendar-check mr-2px"></i>
              <span class="text-nowrap">
                                Jan 2020
                            </span>
              -
              <span class="text-nowrap">
                                Jan 2021
                            </span>
              <i class="fa fa-caret-down ml-2px"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-caret dropdown-animated dd-appear-center dd-slide-none-md">
              <div class="dropdown-inner">
                <a class="dropdown-item m-1 btn btn-sm btn-light-secondary btn-h-light-blue btn-a-blue text-600" href="#">Today</a>
                <a class="dropdown-item m-1 btn btn-sm btn-light-secondary btn-h-light-blue btn-a-blue text-600" href="#">Yesterday</a>
                <a class="dropdown-item m-1 btn btn-sm btn-light-secondary btn-h-light-blue btn-a-blue text-600" href="#">Last Week</a>
                <a class="dropdown-item m-1 btn btn-sm btn-light-secondary btn-h-light-blue btn-a-blue text-600" href="#">Last Month</a>
                <a class="dropdown-item m-1 btn btn-sm btn-light-secondary btn-h-light-blue btn-a-blue text-600 active" href="#">Custom Range</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body p-1 p-md-3 h-100 d-flex align-items-center">
        <canvas id="revenue-expense-chart" class="mx-md-0" height="140"></canvas>
      </div><!-- .card-body -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Chart"
}
</script>

<style scoped>

</style>
